


// THIS CODE IS GENERATED.  CHANGES MADE TO THIS FILE WILL BE LOST.

import { Injectable } from '@angular/core';

import { ClientBase, ClientVersion} from '../shared/core/ovs.core';
import { ResortApplicationConfiguration, SessionValidationResult } from '../models/presentation.model';
import { CookieService } from '@ngx-toolkit/cookie';


export abstract class ApplicationConfigurationClientBase extends ClientBase {
	public abstract Get(params: any, success?: (value: ResortApplicationConfiguration) => void, error?: (error: any) => void): void;
	public abstract GetClientVersion(success?: (value: ClientVersion) => void, error?: (error: any) => void): void;
	public abstract ValidateSession(intervalId: number, inventoryId: string, success?: (value: SessionValidationResult) => void, error?: (error: any) => void): void;
}

@Injectable()
export class ApplicationConfigurationClient extends ApplicationConfigurationClientBase {

	constructor(private cookieService: CookieService) {
		super();
	}

	public Get(params: any, success?: (value: ResortApplicationConfiguration) => void, error?: (error: any) => void): void {
		if (this.cookieService.hasItem("ErrorRedirectUrl")) {
			params.errorRedirectUrl = this.cookieService.getItem("ErrorRedirectUrl");
		}

		this.basePost<ResortApplicationConfiguration>("api/ApplicationConfiguration/ResortAppConfig", ResortApplicationConfiguration, params, success, error);
	}

	public GetClientVersion(success?: (value: ClientVersion) => void, error?: (error: any) => void): void {
		this.baseGet<ClientVersion>("api/ApplicationConfiguration/GetVersion", ClientVersion, null, success, error);
	}

	public ValidateSession(intervalId: number, inventoryId: string, success?: (value: SessionValidationResult) => void, error?: (error: any) => void): void {
		let params: any = {};
		params.IntervalId = intervalId;
		params.IntervalId = intervalId;
		this.basePost<SessionValidationResult>("api/ApplicationConfiguration/ValidateSession", SessionValidationResult, params, success, error);
	}
}








// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/application-configuration.client.ts